import React, { useEffect, useState } from "react";
import SpecialOfferHeader from "../component/Offers/SpecialOfferHeader.jsx";
import FoodItem from "../component/Offers/FoodItem.jsx";
import Header from "../component/layout/Header.jsx";
import Footer from "../component/layout/Footer.jsx";
import { FaSpinner, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import api from "../utils/api.js";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie"
import { addToCart } from "../redux/action/cart.js";
import { toast } from "react-toastify";
import sectionImage from "../assets/Section.png";
import AboveHeaderImage from "../assets/aboveheaderimage.png";
import { showCustomAlert } from "../component/User/Signup/Toast.jsx";
function OfferPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);

  const dispatch = useDispatch();
  const { offerId } = useParams();
  const navigation = useNavigate();
  const navigate = useNavigate();
  const selectedRestaurantId = useSelector(
    (state) => state.restaurant.selectedRestaurantId
  );
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  console.log("🚀 ~ OfferPage ~ products:", products)
  // console.log("🚀 ~ OfferPage ~ products:", products);
  const [offers, setOffers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerSlide, setItemsPerSlide] = useState(4);   const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))
    const statusRes =  Cookies.get(`restaurantStatus_${RestaurantSavedId}`)
  const { cart } = useSelector((state) => state.cart);

  // Adjust items per slide based on screen size
  useEffect(() => {
    const updateItemsPerSlide = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 768 && screenWidth < 1024) {
        setItemsPerSlide(6); // md screens: 6 items
      } else if (screenWidth >= 1024) {
        setItemsPerSlide(8); // lg and above: 8 items
      } else {
        setItemsPerSlide(4); // sm and below: 4 items
      }

      // Reset the currentIndex to 0 when screen size changes
      setCurrentIndex(0);
    };

    updateItemsPerSlide(); // Initial setup
    window.addEventListener("resize", updateItemsPerSlide);

    return () => window.removeEventListener("resize", updateItemsPerSlide);
  }, []);

  const handleOfferClick = (offerId) => {
    navigate(`/offer/${offerId}`); // Navigate to the offer detail page
  };
  useEffect(() => {
    const fetchOffersOrProducts = async () => {
      setLoading(true); // Start loading
      try {
        const response = await api.get(`/offer?restaurantId=${selectedRestaurantId}`);
        if (response.status === 200) {
          // Filter out expired offers
          const currentDate = new Date();
          const validOffers = response.data.results.filter(
            (offer) => new Date(offer.endDate) >= currentDate
          );

          setOffers(validOffers);

          const productPromises = validOffers.flatMap((offer) =>
            offer.applicableProducts.map(async (product) => {
              try {
                const productResponse = await api.get(
                  `/menu-food/${product.menuFoodId}`
                );
                return {
                  ...productResponse.data.data,
                  discount: offer.discountValue,
                  offerId: offer._id,
                };
              } catch (productError) {
                console.error("Error fetching product data:", productError);
                return null;
              }
            })
          );

          const fetchedProducts = await Promise.all(productPromises);
          setProducts(fetchedProducts.filter((product) => product !== null));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchOffersOrProducts();
}, [offerId]);

const addToCartHandler = (product, discountValue) => {
  if (statusRes === 'closed') {
    showCustomAlert({
      title: 'Restaurant is closed!',
      html: '<p style="color: #555;">Restaurant is not accepting orders right now</p>',
      icon: 'suCcess',
      confirmButtonText: 'ok',
      confirmButtonColor: '#af313d',
      background: '#ffffff',
      timer: 4000,
    });
  } else {
    console.log("🚀 ~ addToCartHandler ~ discountValue:", discountValue);

    const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
    const isItemExists = existingCart.find((item) => item.productId === product._id);

    console.log("isItemExists", isItemExists);

    const discountAmount = (product.price * discountValue) / 100;
    console.log("🚀 ~ addToCartHandler ~ discountAmount:", discountAmount);

    const finalPrice = (product.price - (discountAmount || 0)).toFixed(2);
    console.log("🚀 ~ Final Price:", finalPrice);

    if (isItemExists) {
      // Update the quantity of the existing product
      const updatedProduct = {
        ...isItemExists,
        quantity: isItemExists.quantity + 1,
      };

      dispatch(addToCart(updatedProduct));

      // Update localStorage
      const updatedCart = existingCart.map((item) =>
        item.productId === product._id ? updatedProduct : item
      );
      localStorage.setItem('cart', JSON.stringify(updatedCart));

      showCustomAlert({
        title: 'Item Added!',
        html: '<p style="color: #555;">Add More Items to get reward.</p>',
        icon: 'success',
        confirmButtonText: 'View Menu',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
        timer: 4000,
      });
    } else {
      if (product.stock < 1) {
        toast.error("Product stock limited!");
      } else {
        // Add new product to the cart
        const cartData = {
          ...product,
          productId: product._id,
          quantity: 1,
          basePrice: finalPrice,
          actualPrice: product.price,
          offerId,
          image: product.images[0],
        };

        dispatch(addToCart(cartData));

        // Save to localStorage
        const updatedCart = [...existingCart, cartData];
        localStorage.setItem('cart', JSON.stringify(updatedCart));

        showCustomAlert({
          title: 'Item Added!',
          html: '<p style="color: #555;">Add More Items to get reward.</p>',
          icon: 'success',
          confirmButtonText: 'View Menu',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
          timer: 4000,
        });
      }
    }
  }
};


  const handlePageChange = (direction) => {
    setCurrentIndex((prevIndex) => {
      const totalPages = Math.ceil(products.length / itemsPerSlide);
      if (direction === "next") {
        return prevIndex < totalPages - 1 ? prevIndex + 1 : prevIndex;
      } else if (direction === "prev") {
        return prevIndex > 0 ? prevIndex - 1 : prevIndex;
      }
      return prevIndex;
    });
  };

  const visibleProducts = products.slice(
    currentIndex * itemsPerSlide,
    (currentIndex + 1) * itemsPerSlide
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
      </div>
    );
  }

  return (
    <main className="flex flex-col">
      <Header activeLink={"offers"} />
      <div className="relative overflow-visible">
        <img src={sectionImage} className="h-full w-full object-cover" />
        <img
          src={AboveHeaderImage}
          className="absolute top-[-14%] left-[13%] w-[70%] h-auto object-cover z-10"
        />
      </div>
      <SpecialOfferHeader />

      <div className="max-w-full overflow-hidden mt-12">
        {/* Carousel */}
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-16 mb-4 px-4">
          {visibleProducts.map((product, index) => (
            <div key={index} className="flex items-center justify-center">
              <FoodItem
                imageSrc={product.images[0]}
                rating={4.5}
                name={product.name}
                price={product.price}
                description={product.description}
                discount={product.discount}
                onOrder={() => addToCartHandler(product,offers?.[index]?.discountValue)}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Pagination Controls */}
      {products.length > itemsPerSlide && (
        <div className="flex justify-between items-center px-4">
          <button
            onClick={() => handlePageChange("prev")}
            disabled={currentIndex === 0}
            className="p-2 hover:bg-gray-300 rounded-r-lg"
          >
            <FaArrowLeft />
          </button>

          {/* <span className="px-4">
            Page {currentIndex + 1} of {Math.ceil(products.length / itemsPerSlide)}
          </span> */}

          <button
            onClick={() => handlePageChange("next")}
            disabled={
              currentIndex === Math.ceil(products.length / itemsPerSlide) - 1
            }
            className="p-2 hover:bg-gray-300 rounded-r-lg"
          >
            <FaArrowRight />
          </button>
        </div>
      )}
      <header className="flex z-10 flex-col self-center md:mt-[5rem] mt-[80px] max-w-full md:w-[60%] w-[80%] mb-16">
        <h1
          style={{ letterSpacing: "4px" }}
          className="self-center md:text-[33.85px] text-[17px] font-baloo font-bold text-[#191919] mb-4"
        >
          {" "}
          {/* Added mb-4 for bottom spacing */}
          Today <span className="text-[#AD343E]">Special</span> Offers
        </h1>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {offers.map(
          (offer) =>
            offer && (
              <div
                key={offer._id}
                className="rounded-lg overflow-hidden shadow-lg cursor-pointer border border-gray-200 flex flex-col"
                onClick={() => handleOfferClick(offer._id)}
              >
                <div className="relative" style={{ height: "80%" }}>
                  <img
                    src={offer.image} // Dynamically loaded image
                    alt={offer.title} // Dynamically loaded alt text
                    className="w-full h-full object-cover"
                  />
                </div>
                <div
                  className="p-4 body flex items-center justify-center bg-[#AD343E] flex-shrink-0 text-center"
                  style={{ height: "20%" }}
                >
                  <h3 className="text-lg font-medium text-white">
                    {offer.title}
                  </h3>
                </div>
              </div>
            )
        )}
      </div>
      <Footer />
    </main>
  );
}

export default OfferPage;
